import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'

import { CheckBoxFillIcon } from '@flowwai-frontend/design-system/icons'

import { imageUrls } from '../../../constants/imageConstants'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import { MapStyleEnum } from '../../../types'
import MapTooltip from '../../MapTooltip/MapTooltip'
import * as Styles from './styles'

interface Props {
   selectedMapStyle: MapStyleEnum
   handleOnChangeMapPreview: (mapStyle: MapStyleEnum) => void
}

const MapStyleTool = (props: Props): React.ReactElement => {
   const { selectedMapStyle, handleOnChangeMapPreview } = props

   const { mapsT, serviceProvidersConfig } = useMapsUtilityContext()

   const hasSupportForStreetView =
      serviceProvidersConfig.maps.serviceProvider === 'GOOGLE_MAPS'

   const renderTypeOfMapPreview = (
      mapStyle: MapStyleEnum,
      imgUrl: string,
      text: string
   ): ReactElement => {
      const isSelected = mapStyle === selectedMapStyle

      return (
         <div
            className={Styles.getIsActiveViewStyle(isSelected)}
            onClick={() => handleOnChangeMapPreview(mapStyle)}
            data-tooltip-id={mapStyle}
         >
            <img
               src={imgUrl}
               alt={text}
               height={36}
               width={36}
               className='rounded-xl'
            />
            {isSelected ? (
               <div className='absolute -top-6px -right-6px'>
                  <CheckBoxFillIcon />
               </div>
            ) : null}
            <MapTooltip
               tooltipId={mapStyle}
               content={mapsT('mapViewTooltip', { mapView: text })}
            />
         </div>
      )
   }

   return (
      <React.Fragment>
         {renderTypeOfMapPreview(
            MapStyleEnum.Default,
            imageUrls.mapStreetPreview,
            mapsT('mapView')
         )}
         {renderTypeOfMapPreview(
            MapStyleEnum.Satellite,
            imageUrls.mapSatellitePreviewV2,
            mapsT('satelliteView')
         )}
         {hasSupportForStreetView
            ? renderTypeOfMapPreview(
                 MapStyleEnum.Street,
                 imageUrls.mapStreetPreviewV2,
                 mapsT('streetView')
              )
            : null}
      </React.Fragment>
   )
}

export default observer(MapStyleTool)
